<template>
    <div>
        <a-card title="导入导出管理">
            <a-button v-if="C.Env != 'pro'" slot="extra" type="primary" @click="handleCompare">测试环境同步</a-button>
            <a-radio-group v-model="searchP.extype" @change="handeleExtypeChange">
                <a-radio-button value="export">
                    导出配置
                </a-radio-button>
                <a-radio-button value="import">
                    导入配置
                </a-radio-button>
            </a-radio-group>
            <a-button type="primary" @click="handleNewConfig" style="float:right;">新建配置</a-button>
            <br />
            <br />
            <platformTab @platformcodeChange="handlePlatformChange"></platformTab>

            <a-form layout="inline" @submit="handleSubmit" :form="form">
                <a-form-item label="关键字">
                    <a-input v-model="searchP.keyword" style="width:400px" placeholder="beanid/businesstype"></a-input>
                </a-form-item>

                <a-form-model-item label="版本">
                    <a-select v-model="searchP.version" placeholder="" style="width: 80px">
                        <a-select-option value=""> 全部 </a-select-option>
                        <a-select-option value="V3.0"> 3.0 </a-select-option>
                        <a-select-option value="V5.0"> 5.0 </a-select-option>
                    </a-select>
                </a-form-model-item>

                <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
                </a-form-item>
                <a-form-item>
                    <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                    </a-button>
                </a-form-item>

                <a-tooltip placement="top">
                    <template slot="title">
                        <span>beanid已存在的记录会被忽略</span>
                    </template>
                    <a-upload name="file" :multiple="true" style="float:right;" action="https://032001.zhonglunnet.com" :headers="headers" :data="handleImportFile" @change="handleChange">
                        <a-button type="primary" :loading="isImporting">
                            <a-icon type="upload" /> 导入
                        </a-button>
                    </a-upload>
                </a-tooltip>
                <a-button type="primary" style="float:right;margin-right:20px;" @click="handleExportService('export_all')" :loading="isExporting">导出全部</a-button>

                <a-button type="primary" style="float:right;margin-right:20px;" @click="handleExportService('export_select')" :loading="isExporting">导出选中</a-button>

            </a-form>

            <!-- 系统列表 -->
            <a-table :columns="columns" :scroll="{ x: clientWidth}" :style="{width:tableWidth,marginTop:'20px'}" :data-source="list" :pagination="false" :loading="tLoading" rowKey="id" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,type:rowsType}">
                <span slot="savesuccessresult" slot-scope="text">{{ text == '1' ? '是' : '否' }}</span>
                <template slot="operation" slot-scope="text, record">
                    <div class="editable-row-operations">
                        <span>
                            <router-link :to="{
                                path:'edit',
                                query: {
                                    id: record.id,
                                    type:searchP.platformcode,
                                    extype:searchP.extype
                                }
                            }">编辑</router-link>
                        </span>
                        <span>
                            <a-popconfirm title="确认删除？" @confirm="() => onRecordDelete(record)">
                                <a>删除</a>
                            </a-popconfirm>
                        </span>
                        <span>
                            <router-link :to="{
                            path:'copy',
                            query: {
                                id: record.id,
                                type:searchP.platformcode,
                                extype:searchP.extype
                            }
                        }">复制</router-link>
                        </span>
                    </div>
                </template>
            </a-table>

            <a-pagination class="my_pagenation" v-model="searchP.page" :total="searchP.total" @change="handlePageChange" show-less-items show-quick-jumper />

        </a-card>
    </div>
</template>

<script>
import platformTab from '../com/platformtab.vue'

let searchP = {
    extype: 'export',
    platformcode: '',
    keyword: '',
    total: 0,
    pageSize: 10,
    page: undefined,
    version: '',
}
const colums_export = [
    {
        title: '序号',
        width: 50,
        align: 'center',
        customRender: (text, record, index) => {
            let { page, pageSize } = searchP
            return (Number(page) - 1) * Number(pageSize) + index + 1
        },
    },
    {
        title: '版本',
        dataIndex: 'version',
        align: 'center',
        width: 50,
    },
    {
        title: 'serviceKey',
        dataIndex: 'beanid',
        align: 'center',
        ellipsis: true,
        width: 380,
    },
    {
        title: '业务类型',
        dataIndex: 'businesstype',
        align: 'center',
        ellipsis: true,
        width: 180,
    },
    {
        title: '业务全称',
        dataIndex: 'businesstypename',
        align: 'center',
        ellipsis: true,
        width: 180,
    },
    {
        title: 'excel 头配置',
        dataIndex: 'columnheadconfig',
        align: 'center',
        width: 120,
        ellipsis: true,
    },
    {
        title: '文件前缀',
        dataIndex: 'filenameprefix',
        align: 'center',
        width: 120,
        ellipsis: true,
    },
    {
        title: '分文件条数',
        dataIndex: 'datacountperfile',
        align: 'center',
        width: 100,
    },
    {
        title: '最大导出条数',
        dataIndex: 'maxdatacount',
        align: 'center',
        width: 120,
    },
    {
        title: '操作',
        dataIndex: 'operation',
        width: 200,
        align: 'center',
        scopedSlots: { customRender: 'operation' },
    },
]
const colums_import = [
    {
        title: '序号',
        width: 50,
        align: 'center',
        customRender: (text, record, index) => {
            let { page, pageSize } = searchP
            return (Number(page) - 1) * Number(pageSize) + index + 1
        },
    },
    {
        title: '版本',
        dataIndex: 'version',
        align: 'center',
        width: 50,
    },
    {
        title: 'seaviceKey',
        dataIndex: 'beanid',
        align: 'center',
        ellipsis: true,
        width: 380,
    },
    {
        title: '业务类型',
        dataIndex: 'businesstype',
        align: 'center',
        ellipsis: true,
        width: 180,
    },
    {
        title: '业务全称',
        dataIndex: 'businesstypename',
        align: 'center',
        ellipsis: true,
        width: 180,
    },
    {
        title: '字段名',
        dataIndex: 'columnstr',
        align: 'center',
        width: 100,
        ellipsis: true,
    },
    {
        title: '列名',
        dataIndex: 'columnnamestr',
        align: 'center',
        width: 100,
        ellipsis: true,
    },
    {
        title: '开始行数',
        dataIndex: 'startindex',
        align: 'center',
        width: 80,
    },
    {
        title: '最大条数限制',
        dataIndex: 'datacountlimit',
        align: 'center',
        width: 100,
    },
    {
        title: '保存成功记录',
        dataIndex: 'savesuccessresult',
        align: 'center',
        scopedSlots: { customRender: 'savesuccessresult' },
        width: 100,
    },
    {
        title: '操作',
        dataIndex: 'operation',
        width: 180,
        align: 'center',
        scopedSlots: { customRender: 'operation' },
    },
]

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            tLoading: false,
            searchP: searchP,
            list: [],
            clientWidth: 800,
            tableWidth: '800px',
            columns: colums_export,
            isExporting: false,
            isImporting: false,
            exportId: '',
            importId: '',
            checkStatuesTime: 0,
            selectedRowKeys: [],
            rowsType: 'checkbox',
            headers: {
                authorization: 'authorization-text',
            },
        }
    },
    methods: {
        handleCompare() {
            this.$router.push({
                path: 'compare',
                query: {
                    extype: this.searchP.extype,
                    platformcode: this.searchP.platformcode,
                },
            })
        },
        getTableWidth() {
            this.tableWidth = document.body.clientWidth - 282 + 'px'
        },
        handlePlatformChange(v) {
            this.searchP.platformcode = v
            this.searchP.keyword = ''
            this.searchP.page = 1
            this.getData()
        },
        handeleExtypeChange() {
            this.getData()
        },
        //新增配置
        handleNewConfig() {
            this.$router.push({
                path: 'add',
                query: {
                    type: this.searchP.platformcode,
                    extype: this.searchP.extype,
                },
            })
        },
        getData() {
            this.columns =
                this.searchP.extype == 'export' ? colums_export : colums_import
            this.tLoading = true
            this.$store
                .dispatch({
                    type:
                        'filemanager/querycommon' +
                        this.searchP.extype +
                        'config',
                    params: {
                        ...this.searchP,
                        urlparams: false,
                    },
                })
                .then((res) => {
                    this.tLoading = false
                    let result = res.data.data
                    this.list = result.list
                    this.searchP.total = result.totalRecords
                })
        },
        //筛选提交
        handleSubmit(e) {
            e && e.preventDefault()
            this.searchP.page = 1
            this.getData()
        },
        // 分页事件
        handlePageChange(c) {
            this.searchP.page = c
            this.getData()
        },
        //筛选重置
        handleSearchReset() {
            this.searchP.page = 1
            this.searchP.keyword = ''

            this.getData()
        },

        //删除记录
        onRecordDelete(record) {
            this.tLoading = true
            this.$store
                .dispatch({
                    type:
                        'filemanager/deletecommon' +
                        this.searchP.extype +
                        'config',
                    params: {
                        id: record.id,
                        platformcode: this.searchP.platformcode,
                        urlparams: false,
                    },
                })
                .then((res) => {
                    console.log(res)
                    if (res.data.success == '1') {
                        this.message.success('删除成功！')
                    } else {
                        this.message.error('删除失败')
                    }
                    this.getData()
                })
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys
        },
        handleExportService(flag) {
            let exportIds = this.selectedRowKeys.join(',')
            if (flag == 'export_select') {
                //导出选中
                if (!exportIds) {
                    this.message.error('请勾选需要导出的列')
                    return
                }
            } else {
                //导出所有
                if (exportIds) {
                    this.message.error('导出所有时，请不要选中列')
                    return
                }
            }
            let businesstype =
                this.searchP.extype == 'export'
                    ? 'fmsExportPlatformConfig'
                    : 'fmsExportPlatformImportConfig'
            this.isExporting = true
            this.$store
                .dispatch({
                    type: 'servicekey/exportService',
                    params: {
                        exportbusinesstype: businesstype,
                        exportparamsdesc: '{}',
                        type: this.searchP.platformcode,
                        exportids: exportIds,
                        urlparams: false,
                    },
                })
                .then((res) => {
                    if (res.data.success == '1') {
                        console.log(res)
                        this.exportId = res.data.data
                        this.checkExportStatue()
                    } else {
                        this.isExporting = false
                        this.message.error('导出失败')
                    }
                })
                .catch((e) => {
                    this.isExporting = false
                    this.message.error('导出失败' + e.message)
                })
        },

        checkExportStatue() {
            if (this.checkStatuesTime > 3) {
                this.message.error('超出请求次数')
                this.checkStatuesTime = 0
                clearTimeout(this.timer)
                this.isExporting = false
                return
            }
            let that = this
            this.timer = setTimeout(function () {
                that.$store
                    .dispatch({
                        type: 'servicekey/checkExportStatue',
                        params: { id: that.exportId },
                    })
                    .then((res) => {
                        if (res.data.success == 1) {
                            if (res.data.data.exportstatus == 1) {
                                //导出成功
                                that.isExporting = false
                                let temp_File_Str = res.data.data.exportfilefull
                                let files = temp_File_Str.split(',')
                                for (
                                    let index = 0;
                                    index < files.length;
                                    index++
                                ) {
                                    const element = files[index]
                                    window.open(element)
                                }
                            } else {
                                that.checkExportStatue()
                            }
                        } else {
                            that.checkExportStatue()
                        }
                        console.log(res)
                        that.checkStatuesTime++
                    })
            }, 2000)
        },
        //上传文件结果处理
        handleChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList)
            }
            if (info.file.status === 'done') {
                this.saveImportRecord(
                    info.file.objName,
                    info.file.originFileObj.name
                )
                this.message.success(
                    `${info.file.name} file uploaded successfully`
                )
            } else if (info.file.status === 'error') {
                this.message.error(`${info.file.name} file upload failed.`)
            }
        },
        getUniqueCode() {
            const s = []
            const hexDigits = '0123456789abcdef'
            for (let i = 0; i < 36; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
            }
            s[14] = '4'
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
            s[8] = s[13] = s[18] = s[23] = '-'
            return s.join('')
        },
        getSuffix(filename) {
            const pos = filename.lastIndexOf('.')
            let suffix = ''
            if (pos !== -1) {
                suffix = filename.substring(pos)
            }
            return suffix
        },
        handleImportFile(file) {
            // let that = this;
            let result = this.D.syncSelect({
                type: 'servicekey/importConfig',
                params: {},
            })
            if (result.success !== '1') {
                // that.message.error(result['errorMsg']);
                return false
            }
            const data = result.data
            const { dir, policy, accessid, callback, signature } = data
            const token = {
                policy: policy,
                OSSAccessKeyId: accessid,
                success_action_status: '200',
                callback: callback,
                signature: signature,
            }
            const objName =
                dir + this.getUniqueCode() + this.getSuffix(file.name)
            file.objName = objName
            return {
                ...token,
                key: objName,
            }
        },

        saveImportRecord(fileUrl, filename) {
            let businesstype =
                this.searchP.extype == 'export'
                    ? 'fmsImportPlatformConfig'
                    : 'fmsImportPlatformImportConfig'
            this.isImporting = true
            this.$store
                .dispatch({
                    type: 'servicekey/saveImportService',
                    params: {
                        importbusinesstype: businesstype,
                        shopcode: '125806668',
                        loginuserbranchcode: '1001',
                        sourcefile: fileUrl,
                        filename: filename,
                        syncstatus: 1,
                        updownstatus: 1,
                        type: this.searchP.platformcode,
                        urlparams: false,
                    },
                })
                .then((res) => {
                    if (res.data.success == '1') {
                        console.log(res)
                        this.importId = res.data.data
                        this.checkImportStatue()

                        //刷新页面
                        this.$router.push({
                            path: this.action,
                            query: '',
                        })
                    } else {
                        this.isImporting = false
                        this.message.error('导入失败')
                    }
                })
                .catch((e) => {
                    this.isImporting = false
                    this.message.error('导入失败' + e.message)
                })
        },

        checkImportStatue() {
            if (this.checkStatuesTime > 3) {
                this.message.error('超出请求次数')
                this.checkStatuesTime = 0
                clearTimeout(this.timer)
                this.isImporting = false
                return
            }
            let that = this
            this.timer = setTimeout(function () {
                that.$store
                    .dispatch({
                        type: 'servicekey/checkImportStatue',
                        params: { id: that.importId },
                    })
                    .then((res) => {
                        if (res.data.success == 1) {
                            if (res.data.data.importstatus == 1) {
                                //导入成功
                                that.isImporting = false
                            } else if (res.data.data.importstatus == 2) {
                                that.isImporting = false
                                that.message.error(res.data.data.errormsg)
                            } else {
                                that.checkImportStatue()
                            }
                        } else {
                            that.checkImportStatue()
                        }
                        console.log(res)
                        that.checkStatuesTime++
                    })
            }, 2000)
        },
    },

    components: {
        platformTab,
    },

    mounted() {
        this.getTableWidth()
        window.addEventListener('resize', this.getTableWidth)
    },
    destroyed() {
        window.removeEventListener('resize', this.getTableWidth)
    },
}
</script>

<style lang="less" scoped>
.editable-row-operations a {
    margin-right: 8px;
}
td {
    padding: 10px 10px;
}
</style>
